import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { NurturingJourneySettingsComponent } from 'app/pages/NurturingJourneySettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_NURTURING_JOURNEY } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useNurturingJourneySettingsPage } from './hooks/useNurturingJourneySettingsPage';

const NurturingJourneySettingsPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useNurturingJourneySettingsPage();

  return (
    <>
      <Helmet>
        <title>Nurturing Journey Settings</title>
        <meta
          name="description"
          content="Configure nurturing journey settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Nurturing Journey Settings"
        headerSubtitle={
          hasDealer ? (
            <Typography variant="subtitle1" color="text.secondary">
              {dealerTitle ? `${dealerTitle} (${dealerId})` : dealerId}
            </Typography>
          ) : undefined
        }
        contentVariant="centered"
      >
        <NurturingJourneySettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  NurturingJourneySettingsPage,
  CONFIGURE_RESOURCE_NURTURING_JOURNEY,
);
